"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

require("../../../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var Logo = function Logo(props) {
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    className: (0, _classnames.default)("logo-" + props.id, props.className)
  }));
};

Logo.propTypes = {
  className: _propTypes.default.string,
  id: _propTypes.default.string
};
Logo.defaultProps = {
  className: "",
  id: "pingone"
};
var _default = Logo;
exports.default = _default;
module.exports = exports["default"];